import Link from 'next/link'

import Text from 'components/atomic/atoms/text'

const SharedAnchor = ({ href, ...props }) => {
  // Anchors
  if (href.startsWith('#')) {
    return <Text as="a" href={href} {...props} />
  }

  // External links
  if (href.startsWith('http')) {
    return (
      <Text as="a" href={href} target="_blank" rel="noreferrer" {...props} />
    )
  }

  return <Link href={href} {...props} />
}

export default SharedAnchor
